import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';
import { CloseDialog } from '../../shared/dialog-close/dialog-close';
import { AuthService } from '../../auth/auth/auth.service';
import { UserSubmitNewBusinessComponent } from '../user-submit-new-business/user-submit-new-business.component';
var SubmitNewBusinessComponent = /** @class */ (function () {
    function SubmitNewBusinessComponent(_dialogRef, data, _matDialog, _auth) {
        this._dialogRef = _dialogRef;
        this.data = data;
        this._matDialog = _matDialog;
        this._auth = _auth;
        this.isLoading = false;
        this.loggedIn = false;
        this.airport = data.airport;
        this.facilityType = data.facilityType;
        this.facilityTitleType = data.facilityType;
        if (data.facilityType === 'business') {
            this.facilityTitleType = 'Business';
        }
    }
    SubmitNewBusinessComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._dialogRef.backdropClick().subscribe(function () {
            var CLOSE_DIALOG = new CloseDialog();
            CLOSE_DIALOG.cancelButtonClicked = true;
            _this._dialogRef.close(CLOSE_DIALOG);
        });
        if (this._auth.authenticated && this._auth.endUser) {
            this.loggedIn = true;
        }
    };
    SubmitNewBusinessComponent.prototype.onSubmit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var CLOSE_DIALOG, dialogRef;
            return tslib_1.__generator(this, function (_a) {
                CLOSE_DIALOG = new CloseDialog();
                dialogRef = this._matDialog.open(UserSubmitNewBusinessComponent, {
                    disableClose: false,
                    autoFocus: true,
                    data: {
                        airport: this.airport,
                        facilityType: this.facilityType
                    }
                });
                this._dialogRef.close(CLOSE_DIALOG);
                return [2 /*return*/];
            });
        });
    };
    return SubmitNewBusinessComponent;
}());
export { SubmitNewBusinessComponent };
